import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

import {authService} from "../services";
import useInvalidateSession from "./use-invalidate-session";

export default function useLogout() {
  const invalidateSession = useInvalidateSession();
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ["logout"],
    queryFn: authService.logout,
    enabled: true,
    throwOnError: false,
  });

  useEffect(() => {
    if (query.isSuccess) {
      invalidateSession();
    }

    if (query.isSuccess || query.isError) {
      navigate("/login", {replace: true});
    }
  }, [query.isSuccess, query.isError]);

  return query;
}
